// extracted by mini-css-extract-plugin
var _1 = "CommentHistory-module__animateUploadProgressBarWidth--tY6T8";
var _2 = "CommentHistory-module__animatedBackground--U_5e1";
var _3 = "CommentHistory-module__sectionHeader--vwt2Q";
var _4 = "CommentHistory-module__threadWrapper--Ztq3b";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "sectionHeader", _4 as "threadWrapper" }
